import React from 'react';

import { globalFiltersInReportRegistry } from 'config/globalFiltersConfiguration/globalFiltersMap';

import { IContract, IProject } from 'store/projectContract.store';

import {
    GlobalFilterConfigItem,
    GlobalFiltersState,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Widget } from 'components/Dashboards/Reporting/reporting.types';
import classes from 'components/pages/ConfirmWidgetPage/components/ReportGlobalFilters/GlobalFiltersInReport.module.scss';
import { GlobalFiltersInReportWrapper } from 'components/pages/ConfirmWidgetPage/components/ReportGlobalFilters/GlobalFiltersInReportWrapper/GlobalFiltersInReportWrapper';

interface Props {
    globalFilters: GlobalFiltersState;
    setGlobalFilters: React.Dispatch<React.SetStateAction<GlobalFiltersState>>;
    widgetGlobalFiltersConfig: GlobalFilterConfigItem[];
    latestVersionId: number | undefined;
    compareVersionId: number | undefined;
    selectedProject: IProject | null;
    selectedContract: IContract | null;
    widget?: Widget;
    componentKey?: string;
}

export const GlobalFiltersInReport = ({
    globalFilters,
    setGlobalFilters,
    widgetGlobalFiltersConfig,
    latestVersionId,
    compareVersionId,
    selectedProject,
    selectedContract,
    widget,
    componentKey,
}: Props) => {
    return (
        <div className={classes.widgetGlobalFIlters}>
            <GlobalFiltersInReportWrapper
                globalFilters={globalFilters}
                setGlobalFilters={setGlobalFilters}
                selectedProject={selectedProject}
                selectedContract={selectedContract}
                widget={widget}
                componentKey={componentKey}
            >
                {widgetGlobalFiltersConfig.map((globalFilterConfig) => {
                    const FilterComponent = globalFiltersInReportRegistry[globalFilterConfig.key];
                    if (!FilterComponent) return null;
                    return (
                        <FilterComponent
                            key={globalFilterConfig.key}
                            name={globalFilterConfig.key}
                            versionId={latestVersionId}
                            compareVersionId={compareVersionId}
                            project={selectedProject}
                            contract={selectedContract}
                            skipFormSet={true}
                        />
                    );
                })}
            </GlobalFiltersInReportWrapper>
        </div>
    );
};
